import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import pinkgarden from "../assets/img/pinkgarden.png";
import jidipi from "../assets/img/jidipi.png";
import switcheroo from "../assets/img/switcheroo.png";
import med from "../assets/img/med.png";
import lyrics from "../assets/img/lyrics.jpg";
import locallife from "../assets/img/locallife.jpg";

// import dev from "../assets/img/dev.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "Switcheroo",
      description:
        "Switcheroo, the Revolutionary Platform for Eco-Friendly Swapping!",
      imgUrl: switcheroo,
    },
    {
      title: "LyricSync",
      description:
        " A website that displays synchronized lyrics while a song plays. Users can search for their favorite tracks, view lyrics in real-time, and even translate them into multiple languages. Built with React, TypeScript, Zustand, and Tailwind CSS.",
      imgUrl: lyrics,
    },
    {
      title: "Pink Garden",
      description: "Anylical Dashboard for the Business Products",
      imgUrl: pinkgarden,
    },
    {
      title: "The Local Life",
      description:
        "A modern farm management platform where farmers can track crop growth, monitor weather conditions, and manage inventory. It includes a marketplace for selling fresh produce directly to consumers.. Built with React, Node.js, Express, and MongoDB.",
      imgUrl: locallife,
    },
    {
      title: "Jidipi",
      description:
        "A travel booking platform with interactive maps, flight booking, and recommendations. Built with React, GraphQL, and Google Maps API.",
      imgUrl: jidipi,
    },
    {
      title: "MedTecg",
      description:
        "A smart healthcare platform offering AI-driven diagnostics, telemedicine, and digital health records. It ensures secure and seamless patient care with real-time data insights. Built with React, Node.js, and AWS for high performance and scalability. ",
      imgUrl: med,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    I build scalable web and mobile apps using React.js,
                    Next.js, TypeScript, and GraphQL, with cloud solutions on
                    Azure. My expertise spans front-end and back-end
                    technologies, ensuring high-performance applications.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    {/* <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav> */}
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane> */}
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
};
